
const AddCaseModal = ({ handleClickAddCaseModal }) => {
  return (
    <section tabIndex={0} onClick={handleClickAddCaseModal} onKeyDown={handleClickAddCaseModal} className="addcase_modal">
      <span>Προσθήκη Υπόθεσης</span>
    </section>
  )
}

export default AddCaseModal